// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/extension/store_builder.proto" (package "bianka.event.activity.v2.extension", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.StoreBuilder
 */
export interface StoreBuilder {
    /**
     * @generated from protobuf field: bianka.event.activity.v2.extension.StoreBuilder.StoreBuilderData store_builder_data = 9
     */
    storeBuilderData?: StoreBuilder_StoreBuilderData;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.StoreBuilder.StoreBuilderData
 */
export interface StoreBuilder_StoreBuilderData {
    /**
     * @generated from protobuf field: optional string id = 1
     */
    id?: string;
    /**
     * @generated from protobuf field: optional int64 user_id = 2
     */
    userId?: number;
    /**
     * @generated from protobuf field: optional bianka.event.activity.v2.extension.StoreBuilder.Niche niche = 3
     */
    niche?: StoreBuilder_Niche;
    /**
     * @generated from protobuf field: repeated bianka.event.activity.v2.extension.StoreBuilder.Banner banners = 4
     */
    banners: StoreBuilder_Banner[];
    /**
     * @generated from protobuf field: optional string store_url = 5
     */
    storeUrl?: string;
    /**
     * @generated from protobuf field: optional string dropshipper = 6
     */
    dropshipper?: string;
    /**
     * @generated from protobuf field: optional bool app_installed = 7
     */
    appInstalled?: boolean;
    /**
     * @generated from protobuf field: optional string status = 8
     */
    status?: string;
    /**
     * @generated from protobuf field: optional bianka.event.activity.v2.extension.StoreBuilder.TabbedCarousel tabbed_carousel = 9
     */
    tabbedCarousel?: StoreBuilder_TabbedCarousel;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.StoreBuilder.Banner
 */
export interface StoreBuilder_Banner {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string url = 2
     */
    url: string;
    /**
     * @generated from protobuf field: int64 niche_id = 3
     */
    nicheId: number;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.StoreBuilder.Niche
 */
export interface StoreBuilder_Niche {
    /**
     * @generated from protobuf field: int64 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string url = 3
     */
    url: string;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.StoreBuilder.TabbedCarousel
 */
export interface StoreBuilder_TabbedCarousel {
    /**
     * @generated from protobuf field: int32 tab_position = 1
     */
    tabPosition: number;
    /**
     * @generated from protobuf field: string tab_asset = 2
     */
    tabAsset: string;
    /**
     * @generated from protobuf field: string tab_logic = 3
     */
    tabLogic: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class StoreBuilder$Type extends MessageType<StoreBuilder> {
    constructor() {
        super("bianka.event.activity.v2.extension.StoreBuilder", [
            { no: 9, name: "store_builder_data", kind: "message", T: () => StoreBuilder_StoreBuilderData }
        ], { "bianka.core.extension.enrichment": { groupName: "event_ng" } });
    }
    create(value?: PartialMessage<StoreBuilder>): StoreBuilder {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<StoreBuilder>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StoreBuilder): StoreBuilder {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bianka.event.activity.v2.extension.StoreBuilder.StoreBuilderData store_builder_data */ 9:
                    message.storeBuilderData = StoreBuilder_StoreBuilderData.internalBinaryRead(reader, reader.uint32(), options, message.storeBuilderData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StoreBuilder, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bianka.event.activity.v2.extension.StoreBuilder.StoreBuilderData store_builder_data = 9; */
        if (message.storeBuilderData)
            StoreBuilder_StoreBuilderData.internalBinaryWrite(message.storeBuilderData, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.StoreBuilder
 */
export const StoreBuilder = new StoreBuilder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StoreBuilder_StoreBuilderData$Type extends MessageType<StoreBuilder_StoreBuilderData> {
    constructor() {
        super("bianka.event.activity.v2.extension.StoreBuilder.StoreBuilderData", [
            { no: 1, name: "id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "niche", kind: "message", T: () => StoreBuilder_Niche },
            { no: 4, name: "banners", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StoreBuilder_Banner },
            { no: 5, name: "store_url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "dropshipper", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "app_installed", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "status", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "tabbed_carousel", kind: "message", T: () => StoreBuilder_TabbedCarousel }
        ]);
    }
    create(value?: PartialMessage<StoreBuilder_StoreBuilderData>): StoreBuilder_StoreBuilderData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.banners = [];
        if (value !== undefined)
            reflectionMergePartial<StoreBuilder_StoreBuilderData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StoreBuilder_StoreBuilderData): StoreBuilder_StoreBuilderData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string id */ 1:
                    message.id = reader.string();
                    break;
                case /* optional int64 user_id */ 2:
                    message.userId = reader.int64().toNumber();
                    break;
                case /* optional bianka.event.activity.v2.extension.StoreBuilder.Niche niche */ 3:
                    message.niche = StoreBuilder_Niche.internalBinaryRead(reader, reader.uint32(), options, message.niche);
                    break;
                case /* repeated bianka.event.activity.v2.extension.StoreBuilder.Banner banners */ 4:
                    message.banners.push(StoreBuilder_Banner.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional string store_url */ 5:
                    message.storeUrl = reader.string();
                    break;
                case /* optional string dropshipper */ 6:
                    message.dropshipper = reader.string();
                    break;
                case /* optional bool app_installed */ 7:
                    message.appInstalled = reader.bool();
                    break;
                case /* optional string status */ 8:
                    message.status = reader.string();
                    break;
                case /* optional bianka.event.activity.v2.extension.StoreBuilder.TabbedCarousel tabbed_carousel */ 9:
                    message.tabbedCarousel = StoreBuilder_TabbedCarousel.internalBinaryRead(reader, reader.uint32(), options, message.tabbedCarousel);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StoreBuilder_StoreBuilderData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string id = 1; */
        if (message.id !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* optional int64 user_id = 2; */
        if (message.userId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.userId);
        /* optional bianka.event.activity.v2.extension.StoreBuilder.Niche niche = 3; */
        if (message.niche)
            StoreBuilder_Niche.internalBinaryWrite(message.niche, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated bianka.event.activity.v2.extension.StoreBuilder.Banner banners = 4; */
        for (let i = 0; i < message.banners.length; i++)
            StoreBuilder_Banner.internalBinaryWrite(message.banners[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional string store_url = 5; */
        if (message.storeUrl !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.storeUrl);
        /* optional string dropshipper = 6; */
        if (message.dropshipper !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.dropshipper);
        /* optional bool app_installed = 7; */
        if (message.appInstalled !== undefined)
            writer.tag(7, WireType.Varint).bool(message.appInstalled);
        /* optional string status = 8; */
        if (message.status !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.status);
        /* optional bianka.event.activity.v2.extension.StoreBuilder.TabbedCarousel tabbed_carousel = 9; */
        if (message.tabbedCarousel)
            StoreBuilder_TabbedCarousel.internalBinaryWrite(message.tabbedCarousel, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.StoreBuilder.StoreBuilderData
 */
export const StoreBuilder_StoreBuilderData = new StoreBuilder_StoreBuilderData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StoreBuilder_Banner$Type extends MessageType<StoreBuilder_Banner> {
    constructor() {
        super("bianka.event.activity.v2.extension.StoreBuilder.Banner", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "niche_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<StoreBuilder_Banner>): StoreBuilder_Banner {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.url = "";
        message.nicheId = 0;
        if (value !== undefined)
            reflectionMergePartial<StoreBuilder_Banner>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StoreBuilder_Banner): StoreBuilder_Banner {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string url */ 2:
                    message.url = reader.string();
                    break;
                case /* int64 niche_id */ 3:
                    message.nicheId = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StoreBuilder_Banner, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string url = 2; */
        if (message.url !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        /* int64 niche_id = 3; */
        if (message.nicheId !== 0)
            writer.tag(3, WireType.Varint).int64(message.nicheId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.StoreBuilder.Banner
 */
export const StoreBuilder_Banner = new StoreBuilder_Banner$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StoreBuilder_Niche$Type extends MessageType<StoreBuilder_Niche> {
    constructor() {
        super("bianka.event.activity.v2.extension.StoreBuilder.Niche", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StoreBuilder_Niche>): StoreBuilder_Niche {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.displayName = "";
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial<StoreBuilder_Niche>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StoreBuilder_Niche): StoreBuilder_Niche {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toNumber();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string url */ 3:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StoreBuilder_Niche, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string url = 3; */
        if (message.url !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.StoreBuilder.Niche
 */
export const StoreBuilder_Niche = new StoreBuilder_Niche$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StoreBuilder_TabbedCarousel$Type extends MessageType<StoreBuilder_TabbedCarousel> {
    constructor() {
        super("bianka.event.activity.v2.extension.StoreBuilder.TabbedCarousel", [
            { no: 1, name: "tab_position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "tab_asset", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "tab_logic", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StoreBuilder_TabbedCarousel>): StoreBuilder_TabbedCarousel {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tabPosition = 0;
        message.tabAsset = "";
        message.tabLogic = "";
        if (value !== undefined)
            reflectionMergePartial<StoreBuilder_TabbedCarousel>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StoreBuilder_TabbedCarousel): StoreBuilder_TabbedCarousel {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 tab_position */ 1:
                    message.tabPosition = reader.int32();
                    break;
                case /* string tab_asset */ 2:
                    message.tabAsset = reader.string();
                    break;
                case /* string tab_logic */ 3:
                    message.tabLogic = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StoreBuilder_TabbedCarousel, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 tab_position = 1; */
        if (message.tabPosition !== 0)
            writer.tag(1, WireType.Varint).int32(message.tabPosition);
        /* string tab_asset = 2; */
        if (message.tabAsset !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tabAsset);
        /* string tab_logic = 3; */
        if (message.tabLogic !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tabLogic);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.StoreBuilder.TabbedCarousel
 */
export const StoreBuilder_TabbedCarousel = new StoreBuilder_TabbedCarousel$Type();
